import { Injectable } from "@angular/core";
import { HttpClientService } from "./http-client.service";
import { Observable } from "rxjs";
import { tap } from "rxjs/operators";

@Injectable()
export class DocumentSecurityLockService {
  constructor(private http: HttpClientService) {}

  public show(id): Observable<any> {
    return this.http
      .get("/api/document_security_locks/" + id)
      .pipe(tap((_) => console.log("DocumentSecurityLockService.show: Ok.")));
  }

  public create(document_proof_id, description): Observable<any> {
    const options = {
      document_proof_id: document_proof_id,
      description: description,
    };
    return this.http
      .post("/api/document_security_locks", options)
      .pipe(tap((_) => console.log("DocumentSecurityLockService.create: Ok.")));
  }

  public update(id, description): Observable<any> {
    const options = {
      description: description,
    };
    return this.http
      .put("/api/document_security_locks/" + id, options)
      .pipe(tap((_) => console.log("DocumentSecurityLockService.update: Ok.")));
  }

  public delete_security_lock(id): Observable<any> {
    return this.http
      .delete(`/api/document_security_locks/${id}/delete_security_lock`)
      .pipe(tap((_) => console.log("DocumentSecurityLockService.delete_security_lock: Ok.")));
  }
}
